import React from 'react';
import { Building2, PlusCircle } from 'lucide-react';

const CompaniesListToolbar = ({ onAddCompany }) => {
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <h5 className="mb-0">Companies</h5>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <button 
                            className="btn btn-outline-primary"
                            onClick={onAddCompany}
                            title="Add New Company"
                        >
                            <PlusCircle size={18} className="me-2" />
                            Add New Company
                        </button>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default CompaniesListToolbar;